import React, { useState, useEffect, useCallback,useRef } from 'react';
// import { ShoppingCart } from 'lucide-react';
import { useStore } from '../../context/StoreContext';
import CartView from '../CartView';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ShareDropdown from '../Common/ShareDropdown';
import { Search, ShoppingCart, Star, Facebook, Twitter, Instagram, Menu, X, ArrowLeft, ChevronRight, ChevronDown, ArrowRight } from 'lucide-react';
import axios from '../../utilities/axios';
import { ReactComponent as ShoppingBag } from '../../assets/images/icons/shopping-bag_1.svg';
import * as API_END_POINT from '../../utilities/constant';
import { Helmet } from 'react-helmet';
import shopDot from '../../assets/images/logo.svg'
import { debounce } from 'lodash';
import Input from '../Common/Input';
import {
    searchProducts,
    isSearchEnabled,
} from '../../services/searchApi';

import logoShopdot from '../../assets/images/logo-png.png';
import { ShowMore } from '../Common/ShowMore';
import HeaderSkeleton from './HeaderSkeleton';
import { fetchProductsWithFallback } from '../../utilities/apiHelper';
import { readableOn } from '../../shared/theme/storefrontTheme';

const SEARCH_FILTERS = [
    { field: 'status', operator: 'in', value: ['1'] },
    { field: 'shopify_status', operator: 'in', value: ['active'] },
];

const useManageKey = () => {
    const location = useLocation();

    useEffect(() => {
        const specificPage = '/checkout/payment-details';
        if (location.pathname === specificPage) {
            let existingKey = localStorage.getItem('idempotency_id');
            if (!existingKey) {
                existingKey = crypto.randomUUID();
                localStorage.setItem('idempotency_id', existingKey);
            }
        } else {
            const newKey = crypto.randomUUID();
            localStorage.setItem('idempotency_id', newKey);
        }
    }, [location.pathname]);
};


const IframeHeader = () => {
    useManageKey();
    const { storeDetails, cartItems, error, pageDetails, headerMenuCategories } = useStore();
    const [currentView, setCurrentView] = useState('main');
    const[productFilters, setProductFilters] = useState(null);
    const [navigationStack, setNavigationStack] = useState(['main']);
    const navigate = useNavigate();
    const location = useLocation();
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [hasCartItems, setHasCartItems] = useState(false);
    const [totalCartItem, SettotalCartItem] = useState(false);
    // Add this state at the top of your component
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const notLaunched = storeDetails?.status && storeDetails?.status !== 'INITIAL_PROCESS_COMPLETED_AND_LAUNCHED';
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    useEffect(() => {
        if (notLaunched) {
            setHasCartItems(false);
            SettotalCartItem(0)
        }
    })
    useEffect(() => {
        setHasCartItems(cartItems?.length > 0);
        let tmep = 0;
        cartItems.map((item) => {
            tmep += item.cart_items.length
        })
        SettotalCartItem(tmep)
    }, [cartItems]);

    const handleCartClick = () => {
        setIsCartOpen(true);
    };

    const handleClose = () => {
        setIsCartOpen(false);
    }

    useEffect(() => {
        // navigate('/store-not-available')
    }, [error])

    useEffect(() => {
        if (storeDetails?.store_name) {
            document.title = storeDetails?.store_name + ` 's Online Store`;

        }
    }, [storeDetails?.store_name]);

    const [activeDropdown, setActiveDropdown] = useState(null);
    const [hoveredAnimal, setHoveredAnimal] = useState(null);

    const animalTags = headerMenuCategories?.find(g => g.tag_group.code === "animal_type")?.tags || [];

    // Get all unique categories across all animals
    const getAllCategories = () => {
        const categoriesMap = new Map();
        animalTags.forEach(tag => {
            tag.categories?.forEach(cat => {
                if (!categoriesMap.has(cat.id)) {
                    categoriesMap.set(cat.id, cat.name, cat.code);
                }
            });
        });
        return Array.from(categoriesMap.entries()).map(([id, name, code]) => ({ id, name, code }));
    };

    const displayCategories = hoveredAnimal
        ? productFilters.find((animal) => animal.code == hoveredAnimal)?.subCategories
        : [];

    const [searchTerm, setSearchTerm] = useState('');
    const [rawSearch, setRawSearch] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [showSearcInput, setShowSearcInput] = useState(false);
    const searchRef = useRef(null);
    const debouncedSetSearch = useCallback(
        debounce((val) => {
            if (val !== searchTerm) setSearchTerm(val);
        }, 500),
        [searchTerm]
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearcInput(false);
                // setRawSearch('');
            }
        };

        if (showSearcInput) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showSearcInput]);


    const fetchProductList = useCallback(async () => {
        if (!searchTerm) {
            setProducts([]);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            if (isSearchEnabled()) {
                const result = await searchProducts(searchTerm, {
                    filters: SEARCH_FILTERS,
                    sort: 'title:asc',
                    limit: 20,
                    offset: 0,
                });
                const hits = result?.data?.items || result?.items || [];
                setProducts(hits);
            } else {
                const filterArr = [];
                const searchKeyword = searchTerm;
                const response = await fetchProductsWithFallback({
                    paging: { limit: 4, offset: 0 },
                    sort: [],
                    ...(filterArr.length ? { filter: filterArr } : null),
                    ...(searchKeyword ? { query: { searchKeyword } } : {})
                });
                setProducts(response.data.data.items);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setIsLoading(false);
        }
    }, [searchTerm]);

    const getAllProductsFilter = async () => {
        const response = await axios.post(
            `${API_END_POINT.PRODUCT_FILTERS}`,
            {}
        );
        setProductFilters(response.data.data?.availableFilters?.categories)
    }

    useEffect(() => {
        fetchProductList();
        getAllProductsFilter();
    }, [fetchProductList]);
    const [menuData, setMenuData] = useState({
        main: {
            title: null,
            items: [
                { label: 'Home', type: 'link', link: "/" },
                { label: 'Shop All', type: 'link', link: "/all-products" },
                { label: 'Categories', type: 'submenu', view: 'categories' },
                { label: 'Brands', type: 'link', link: "/all-brands" },
                // { label: "Today's Deals", type: 'link' },
                { label: 'Collections', type: 'link', link: "/all-collections" }
            ]
        },
        categories: {
            title: 'Categories',
            items: [
                { label: 'All Animals', type: 'link' },
                { label: 'Dog', type: 'submenu', view: 'dog' },
                { label: 'Cat', type: 'submenu', view: 'cat' },
                { label: 'Small Pet', type: 'submenu', view: 'small_pet' },
                { label: 'Horse', type: 'submenu', view: 'horse' }
            ]
        },
        dog: {
            title: 'Dog',
            items: []
        },
        cat: {
            title: 'Cat',
            items: []
        },
        small_pet: {
            title: 'Small Pet',
            items: []
        },
        horse: {
            title: 'Horse',
            items: []
        },
        brands: {
            title: 'Brands'
        },
        collections: {
            title: 'Collections'
        }
    });

    const animals = [{
        "id": 1,
        "name": "Dog",
        "code": "dog",
    }, {
        "id": 2,
        "name": "Cat",
        "code": "cat",
    }, {
        "id": 3,
        "name": "Small Pet",
        "code": "small_pet",
    }, {
        "id": 4,
        "name": "Horse",
        "code": "horse",
    }]
    const handleNavigation = (view) => {
        setCurrentView(view);

        const displayCategories = view
            ? productFilters.find((animal) => animal.code == view)?.subCategories
            : [];
        if (displayCategories?.length) {
            setMenuData({
                ...menuData, [view]: {
                    title: menuData[view]?.title,
                    items: displayCategories ? displayCategories.map((item) => {
                        return { label: item.name,type:"link",link: `/all-products?subcategory=${item.code}&category=${view}` }
                    }) : []
                }
            })
        }

        setNavigationStack([...navigationStack, view]);
    };

    const handleBack = () => {
        const newStack = [...navigationStack];
        newStack.pop();
        const previousView = newStack[newStack.length - 1] || 'main';
        setNavigationStack(newStack);
        setCurrentView(previousView);
    };

    const currentMenu = menuData[currentView];
    useEffect(()=>{
        if(productFilters?.length){
            setMenuData({
                ...menuData,
                categories: {
                    title: 'Categories',
                    items: productFilters?.map(item=>{
                        return {
                            label: item?.name,
                            count: item?.count,
                            // type: 'submenu',
                            view: item?.code,
                            link: `/all-products?category=${item.code}`
                        }
                    })
                }
            })
        }
    }, [productFilters, productFilters?.length])
    return (
        <>
           

            {/* Announcement Bar */}
            {/* <div style={{ background: pageDetails?.page_data?.colorAndApperances.colorTheme }} className={`bg-[${pageDetails?.page_data?.colorAndApperances.colorTheme}] text-white text-center py-[5px] text-sm px-[39px]`}>
                {pageDetails?.page_data?.announcementBarText}
            </div> */}

            {/* Header */}
            {/* TODO:V2: if need to old skeleton use this */}
            {/* <header className={`${notLaunched ? 'cursor-not-allowed pointer-events-none' : ''} bg-white shadow-sm relative`}> */}
            <header className="sticky top-0 z-50 bg-white shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <>
                        {!pageDetails ? (
                            <HeaderSkeleton />
                        ) : (
                            <div className="flex items-center justify-between h-16">
                                {/* Logo / Back Arrow */}
                                <div className="flex items-center">
                                    {location.pathname === "/" ? (
                                        <div onClick={() => navigate("/")}>
                                            {/* {
                                                (storeDetails?.store_logo || pageDetails?.page_data?.logoIdentity?.storeLogo) && <img src={storeDetails?.store_logo || pageDetails?.page_data?.logoIdentity?.storeLogo} alt="Store Logo" className="h-[55px] w-[54px] object-contain" />
                                            } */}
                                        </div>
                                    ) : (
                                        <ArrowLeft
                                            onClick={() => window.history.back()}
                                            size={18}
                                            className="w-5 h-5 text-gray-600 cursor-pointer block md:hidden mr-2 md:mr-[0px]"
                                        />
                                    )}
                                </div>

                                {/* Desktop Navigation */}
                                <nav className="hidden md:flex ">
                                    {pageDetails?.page_data?.homeEnabled !== false && <Link to="/" className="ml-8 text-gray-700 hover:text-gray-900">Home</Link>}
                                    {pageDetails?.page_data?.navLinks?.find(l => l.label === 'Shop All')?.enabled !== false && <Link to="/all-products" className="ml-8 text-gray-700 hover:text-gray-900">Shop All</Link>}
                                    {/* {storeDetails?.user?.business_vertical?.code === 'pet' && ( */}
                                    {pageDetails?.page_data?.navLinks?.find(l => l.label === 'Categories')?.enabled !== false && <div className="flex items-center space-x-8 ml-8">
                                        <div
                                            className="relative"
                                            onMouseEnter={() => setActiveDropdown('categories')}
                                            onMouseLeave={() => setActiveDropdown(null)}
                                        >
                                            <button className={`flex items-center gap-1
                                                    ${activeDropdown === 'categories'
                                                    ? 'text-[#2C2C2C] font-medium'
                                                    : 'text-[#374151]'
                                                    }
                                                    hover:text-[#2C2C2C] hover:font-medium
                                                `}>
                                                <span>Categories</span>
                                                <ChevronDown className="w-4 h-4" />
                                            </button>
                                            {/* Single-column list, matching the public storefront header
                                            (components/Header/index.js). The old "beside" column came
                                            from `displayCategories`, which compared the hovered
                                            category's CODE against the hovered ROW OBJECT and was never
                                            true. `top-full` is the only offset now. */}
                                            {activeDropdown === 'categories' && (
                                                <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 min-w-[220px] max-h-[min(70vh,480px)] overflow-y-auto bg-white rounded-lg shadow-xl border border-gray-200 p-2 z-50">
                                                    {productFilters.filter(tag => tag?.count > 0).map(tag => (
                                                        <button
                                                            key={tag.id}
                                                            onClick={() => {
                                                                navigate(`/all-products?category=${tag.code}`);
                                                                setActiveDropdown(null);
                                                            }}
                                                            className="w-full text-left py-[9px] px-3 rounded-md transition-colors text-[14px] leading-[18px] text-[#565E64] hover:bg-[#F5F6F6] hover:text-[#2C2C2C]"
                                                        >
                                                            {tag.name}
                                                        </button>
                                                    ))}
                                                    <button
                                                        onClick={() => {
                                                            navigate('/all-products');
                                                            setActiveDropdown(null);
                                                        }}
                                                        className="w-full flex items-center gap-[6px] text-left mt-1 pt-3 px-3 border-t border-gray-200 text-[14px] font-semibold text-[#E15439]"
                                                    >
                                                        Shop everything <ArrowRight className="w-[14px] h-[14px]" />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>}
                                    {/* )} */}
                                    {/* <Link to="/all-products" className="ml-8 text-gray-700 hover:text-gray-900">Categories</Link> */}
                                    {pageDetails?.page_data?.navLinks?.find(l => l.label === 'Brands')?.enabled !== false && <Link to="/all-brands" className="ml-8 text-gray-700 hover:text-gray-900">Brands</Link>}
                                    {pageDetails?.page_data?.navLinks?.find(l => l.label === 'Collections')?.enabled !== false && <Link to="/all-collections" className="ml-8 text-gray-700 hover:text-gray-900">Collections</Link>}
                                    {pageDetails?.page_data?.navLinks?.map((navLink, index) => (
                                        navLink.enabled !== false && navLink.label?.trim() && !["Today's Deals", "Shop All", "Categories", "Brands", "Collections"].includes(navLink.label) && <Link
                                            to={navLink.link}
                                            target='_blank'
                                            className="ml-8 text-gray-700 hover:text-gray-900">
                                            {navLink.label}
                                        </Link>
                                    ))}
                                </nav>

                                {/* Desktop Search and Cart */}
                                <div className="hidden md:flex items-center space-x-4">
                                    {showSearcInput && (
                                        <div ref={searchRef} className="relative" onClick={(e) => e.stopPropagation()}>

                                        <Input className='!w-[270px]' value={rawSearch}
                                            onChange={(e) => {
                                                setRawSearch(e.target.value);
                                                debouncedSetSearch(e.target.value);
                                            }}
                                            icon={Search} placeholder="Search" />

                                        {rawSearch && <div className='flex flex-col absolute top-full bg-white w-full rounded-[4px] border border-[#CDD1D4] shadow-[0_12px_16px_-4px_rgba(44,47,50,0.08)] z-50 overflow-hidden' >
                                            {
                                                isLoading ? <SearchLoader /> : products.map((product) => (
                                                    <div onClick={() => {
                                                        setRawSearch('');
                                                        navigate(`product/${product.id}`);
                                                    }} key={product.id} className="w-full p-[16px] flex items-center hover:bg-gray-50 rounded-lg cursor-pointer">
                                                        <div className="flex gap-[8px] items-center w-full ">
                                                            <img
                                                                src={
                                                                    product?.product_images?.find(img => img.is_main === "1")?.src ||
                                                                    product?.product_images?.[0]?.src ||
                                                                    logoShopdot
                                                                }
                                                                alt={product.title}
                                                                className="w-[38px] h-[38px] object-contain rounded-md"
                                                                />

                                                            <div className="min-w-0 flex-1 flex flex-col">
                                                                {/* Product Title */}
                                                                <div className="header-tooltip-container"
                                                                    onMouseEnter={(e) => {
                                                                        const tooltip = e.currentTarget.querySelector('.header-tooltip-text');
                                                                        const rect = e.currentTarget.getBoundingClientRect();
                                                                        if (tooltip) {
                                                                            tooltip.style.left = `${rect.left + rect.width / 2}px`;
                                                                            tooltip.style.transform = 'translateX(-50%) translateY(-100%)';
                                                                        }
                                                                    }}>
                                                                    <div className="header-tooltip-text">
                                                                    {product.title}
                                                                    </div>
                                                                    <h2 className="text-[16px] text-[#2C2F32] font-medium truncate ellipsis-text hover-text">
                                                                    {product.title}
                                                                    </h2>
                                                                </div>

                                                                {/* Brand / Vendor */}
                                                                <div className="header-tooltip-container"
                                                                    onMouseEnter={(e) => {
                                                                        const tooltip = e.currentTarget.querySelector('.header-tooltip-text');
                                                                        const rect = e.currentTarget.getBoundingClientRect();
                                                                        if (tooltip) {
                                                                            tooltip.style.left = `${rect.left + rect.width / 2}px`;
                                                                            tooltip.style.transform = 'translateX(-50%) translateY(-100%)';
                                                                        }
                                                                    }}>
                                                                    <div className="header-tooltip-text">
                                                                    {product?.is_multi_brand
                                                                        ? product?.vendor?.name
                                                                        : product?.brand?.name}
                                                                    </div>
                                                                    <p className="text-[12px] text-[#2c2f32] truncate ellipsis-text">
                                                                    {product?.is_multi_brand
                                                                        ? product?.vendor?.name
                                                                        : product?.brand?.name}
                                                                    </p>
                                                                </div>
                                                                </div>

                                                        </div>

                                                    </div>
                                                ))
                                            }
                                        </div>}
                                    </div>)}
                                    {!showSearcInput && <Search className="w-5 h-5 text-gray-600 cursor-pointer" onClick={(e) => {
                                        e.stopPropagation();
                                        setShowSearcInput(true);
                                    }} />}

                                    <div className="relative cursor-pointer" onClick={handleCartClick} >
                                        <ShoppingCart className="w-5 h-5 text-gray-600 cursor-pointer" />

                                        {cartItems?.length > 0 && (
                                            <span
                                                style={{ backgroundColor: pageDetails?.page_data?.colorAndApperances?.colorTheme || '#E15439', color: readableOn(pageDetails?.page_data?.colorAndApperances?.colorTheme || '#E15439') }}
                                                className="absolute -top-2 -right-2 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center"
                                            >
                                                {totalCartItem > 99 ? '99+' : totalCartItem}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* Mobile Menu Button and Icons */}
                                <div className="flex items-center space-x-4 md:hidden">
                                    {showSearcInput && (
                                        <div ref={searchRef} className="relative" onClick={(e) => e.stopPropagation()}>
                                        <Input className='w-[100px]' value={rawSearch}
                                            onChange={(e) => {
                                                setRawSearch(e.target.value);
                                                debouncedSetSearch(e.target.value);
                                            }}
                                            icon={Search} placeholder="Search" />

                                        {rawSearch && <div className='flex flex-col absolute top-full bg-white w-full rounded-[4px] border border-[#CDD1D4] shadow-[0_12px_16px_-4px_rgba(44,47,50,0.08)] z-10' >
                                            {
                                                isLoading ? <SearchLoader /> : products.map((product) => (
                                                    <div onClick={() => {
                                                        setRawSearch('');
                                                        navigate(`product/${product.id}`);
                                                    }} key={product.id} className="w-full p-[16px] flex items-center justify-between  space-x-3  hover:bg-gray-50 rounded-lg cursor-pointer">
                                                        <div className="flex gap-[8px] items-center w-full min-w-0">
                                                            <img
                                                                src={product?.product_images?.find(img => img.is_main === "1")?.src ||
                                                                    product?.product_images?.[0]?.src ||
                                                                    logoShopdot}
                                                                alt={product.title}
                                                                className=" h-[38px] object-contain rounded-md w-[38px]" 
                                                            />
                                                            <div className="min-w-0 flex-1">
                                                                <h2 className="text-[14px] text-[#2C2F32] font-medium truncate">
                                                                    {product.title}
                                                                </h2>
                                                                <p className="text-[12px] text-[#2c2f32] truncate">
                                                                    {product?.is_multi_brand
                                                                    ? product?.vendor?.name
                                                                    : product?.brand?.name}
                                                                </p>
                                                                </div>

                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>}
                                    </div>)}
                                    {!showSearcInput && <Search className="w-5 h-5 text-gray-600 cursor-pointer" onClick={(e) => {
                                        e.stopPropagation();
                                        setShowSearcInput(true);
                                    }} />}
                                    <div className="relative cursor-pointer" onClick={handleCartClick} >
                                        <ShoppingCart className="w-5 h-5 text-gray-600 cursor-pointer" />

                                        {cartItems?.length > 0 && (
                                            <span
                                                style={{ backgroundColor: pageDetails?.page_data?.colorAndApperances?.colorTheme || '#E15439', color: readableOn(pageDetails?.page_data?.colorAndApperances?.colorTheme || '#E15439') }}
                                                className="absolute -top-2 -right-2 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center"
                                            >
                                                {totalCartItem > 99 ? '99+' : totalCartItem}
                                            </span>
                                        )}
                                    </div>
                                    <button
                                        onClick={toggleMobileMenu}
                                        className="text-gray-700 hover:text-gray-900 focus:outline-none focus:text-gray-900"
                                    >
                                        <Menu className="w-6 h-6" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                </div>
                {/* Mobile Navigation Menu */}
                <div
                    className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out flex flex-col ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
                        }`}
                >
                    {/* Header */}


                    {/* Logo and Close Button */}
                    {
                        !currentMenu.title && <div className="px-4 py-4 flex items-center justify-between ">
                            <div className="flex items-center">
                            </div>
                            <button
                                onClick={() => {
                                    setIsMobileMenuOpen(false)
                                    setCurrentView('main');
                                }}
                                className="text-gray-600 hover:text-gray-800 transition-colors"
                            >
                                <X className="w-6 h-6" />
                            </button>
                        </div>
                    }


                    {/* Navigation Header */}
                    {currentMenu.title && (
                        <div className="px-4 py-4 flex items-center justify-between">
                            <div className="flex items-center justify-normal">
                                <button
                                    onClick={handleBack}
                                    className="mr-3 text-gray-600 hover:text-gray-800 transition-colors"
                                >
                                    <ArrowLeft className="w-5 h-5" />
                                </button>
                                <h2 className="text-lg font-semibold text-gray-800">{currentMenu.title}</h2>
                            </div>

                            <button
                                onClick={() => {
                                    setIsMobileMenuOpen(false)
                                    setCurrentView('main');
                                }}
                                className="text-gray-600 hover:text-gray-800 transition-colors"
                            >
                                <X className="w-6 h-6" />
                            </button>
                        </div>
                    )}

                    {/* Menu Items */}
                    <div className="flex-1  overflow-y-auto">
                        <nav className="py-2 flex gap-[25px] flex-col">
                            {currentMenu.items.filter(item=> (currentView !== "categories" || item?.count > 0) && (item.label !== 'Home' || pageDetails?.page_data?.homeEnabled !== false)).map((item, index) => (
                                <button
                                    key={index}
                                    onClick={() => {
                                        // navigate(`/all-products?category=${item.view}`)
                                        if (item.type === 'submenu') {
                                            handleNavigation(item.view);
                                        } else {
                                            navigate(item.link)
                                            setIsMobileMenuOpen(false)
                                            setCurrentView('main');
                                            // Handle link click
                                            // console.log('Navigate to:', item);
                                        }
                                    }}
                                    className="w-full px-6 h-[32px]  flex items-center  justify-between transition-colors text-left border-gray-100"
                                >
                                    <span className="text-gray-700 text-base">{item.label}</span>
                                    {/* {currentView === 'categories' && (
                                        <span className="bg-[#F5F6F6] text-gray-600 text-xs px-2 py-1 rounded-[7px] hover:font-medium ">
                                            {item?.count|| 0}
                                        </span>
                                    )} */}
                                    {item.type === 'submenu' && (
                                        <ChevronRight className="w-5 h-5 text-gray-400" />
                                    )}
                                </button>
                            ))}

                            {pageDetails?.page_data?.navLinks?.map((navLink, index) => (
                                navLink.enabled !== false && navLink.label?.trim() && !["Today's Deals", "Shop All", "Categories", "Brands", "Collections"].includes(navLink.label) &&
                                <button
                                    key={index}
                                    onClick={() => {
                                        navigate(navLink.link);
                                    }}
                                    className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors text-left border-gray-100"
                                >
                                    <span className="text-gray-700 text-base">{navLink.label}</span>
                                </button>
                            ))}
                        </nav>
                    </div>

                    {/* Cart Footer */}
                    <div className=" border-gray-200 p-4">
                        <button onClick={()=>  {setIsCartOpen(true); setIsMobileMenuOpen(false)}} className="w-full flex items-center justify-start py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors">
                            <div className="relative mr-3" >
                                <ShoppingCart className="w-5 h-5 text-gray-600 cursor-pointer" />
                                {cartItems?.length > 0 && (
                                    <span
                                        style={{ backgroundColor: pageDetails?.page_data?.colorAndApperances?.colorTheme || '#E15439', color: readableOn(pageDetails?.page_data?.colorAndApperances?.colorTheme || '#E15439') }}
                                        className="absolute -top-2 -right-2 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center"
                                    >
                                        {totalCartItem > 99 ? '99+' : totalCartItem}
                                    </span>
                                )}
                            </div>
                            <span className="text-lg font-normal">Cart</span>
                        </button>
                    </div>
                </div>
            </header>

            {/* Overlay to close mobile menu when clicking outside */}
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-25 z-40 md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                ></div>
            )}

            <CartView isOpen={isCartOpen} onClose={handleClose} />
        </>
    );
};

export default IframeHeader;
export function SearchLoader() {
    return (
        <div className="flex items-center gap-4 p-4">
            {/* Product Image Skeleton */}
            <div className="w-[38px] h-[38px] bg-gray-200 rounded animate-pulse flex-shrink-0" />

            {/* Product Title Skeleton */}
            <div className="flex-1">
                <div className="h-8 bg-gray-200 rounded animate-pulse max-w-xs" />
            </div>
        </div>
    );
}